<template>
	<div class="pictureList">
		<div class="cover"></div>
		<div>
			<i class="el-icon-close close" @click="close"></i>
			<div class="imageItem">
				<el-image :src="imgUrl" style="width: 70vw; height: 70vh;"></el-image>
			</div>
			<div class="imageList">
				<el-image v-for="(item,index) in pictureList" style="width: 50px; height:70px; cursor: pointer;" :src="item.picturePath"
				 :key="index" @click="switchImg(index)"></el-image>
			</div>
		</div>
		
	</div>
</template>

<script>
	import {Decrypt,Encrypt} from '@/common/secret.js'
	export default {
		data() {
			return {
				imgUrl: '',
				show:false
			}
		},
		props: {
			pictureList: {
				type: Array,
				default: []
			}
		},
		mounted() {
			this.imgUrl = this.pictureList[0].picturePath
			
		},
		methods: {
			switchImg(index) {
				this.imgUrl = this.pictureList[index].picturePath
				console.log(this.pictureList[index].picturePath)
			},
			close() {
				this.$emit('update:showPictureList',false)
			}
		}
	}
</script>

<style scoped="scoped">
	.pictureList {
		
	
	}
	.close {
		font-size: 30px;
		color: #eee;
		position: absolute;
		top: 0;
		right: 0;
		cursor: pointer;
		z-index: 999;
	}
	.cover {
		background-color: black;
		position: absolute;
		/* float: left; */
		left: 0px;
		top: 0px;
		width: 100vw;
		height: 100vh;
		filter: alpha(opacity=30);
		opacity: 0.5;
		z-index: 999;

	}

	.imageItem {
		position: absolute;
		z-index: 9999;
		top: 10%;
		left: 50%;
		transform: translateX(-50%);
	}

	.imageList {
		position: absolute;
		z-index: 9999;
		bottom: 15px;
		left: 50%;
		transform: translateX(-50%);
	}
</style>
